import React, { useState } from "react";

import thrashIcon from "assets/images/ic-thrash-red.svg";
import editIcon from "assets/images/ic-edit-black.svg";
import Icon from "components/Icon";
import {ICONS} from "constants/svgIcons";
import StorageService from "services/StorageService";
import {SESSION} from "constants/storageConstants";
import ActivationCodeService from "services/activationCode";
import toastr from "toastr";


const ActionsComponent = ({ item, handleEdit, handleDelete, withCSVDownloadButton }) => {
    const token = new StorageService().getValueByKey(SESSION)?.accessToken;
    const [isDownloadingEmails, setIsDownloadingEmails] = useState(false);

    const handleDownloadEmailsCSV = async () => {
        if (isDownloadingEmails) return;
        
        try {
            setIsDownloadingEmails(true);
            await ActivationCodeService.downloadActivationCodeEmailsCSV(item.id, item.code);
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || 'Failed to download emails CSV';
            toastr.error(errorMessage);
        } finally {
            setIsDownloadingEmails(false);
        }
    };

    return (
        <div className="d-flex align-items-center action-buttons">
            {item.hasAttachedEmails && (
                <span
                    className={`action-icon downloadLink cursor-pointer ${isDownloadingEmails ? 'opacity-50' : ''}`}
                    title="Download emails CSV"
                    onClick={handleDownloadEmailsCSV}
                    style={{ pointerEvents: isDownloadingEmails ? 'none' : 'auto' }}
                >
                    <Icon icon={ICONS.downloadIcon}/>
                </span>
            )}
            {withCSVDownloadButton && (
                <a
                    className="action-icon downloadLink"
                    title="Download CSV"
                    href={`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_API_VERSION}/clinical-admins/activation-codes/${item.id}/csv?access_token=${token}`}
                >
                    <Icon icon={ICONS.envelopeWithArrow}/>
                </a>
            )}
            {handleEdit && (
                <span className="action-icon cursor-pointer" onClick={() => handleEdit(item)} title="Edit">
                    <img src={editIcon} alt="Edit"/>
                </span>
            )}
            {handleDelete && (
                <span className="action-icon cursor-pointer" onClick={() => handleDelete(item)} title="Delete">
                    <img src={thrashIcon} alt="Delete"/>
                </span>
            )}
        </div>
    )
}

export default ActionsComponent;
